import { CURRENT_POLICY, USER_ID, CURRENT_POLICY_LOB, CURRENT_POLICY_STATE, CURRENT_POLICY_STATUS, CURRENT_POLICY_PRODUCT_CODE } from '@prcins/constants';
import * as i0 from "@angular/core";
var GliaService = /** @class */ (function () {
    function GliaService() {
    }
    /**
     * Called after login — pushes authenticated visitor context into Glia so
     * the custom engine webhook receives it in visitor_attributes.
     */
    GliaService.prototype.updateVisitorContext = function () {
        if (typeof sm === 'undefined') {
            return; // Glia script not loaded yet
        }
        var policyNumber = sessionStorage.getItem(CURRENT_POLICY) || '';
        var userId = sessionStorage.getItem(USER_ID) || '';
        var lob = sessionStorage.getItem(CURRENT_POLICY_LOB) || '';
        var state = sessionStorage.getItem(CURRENT_POLICY_STATE) || '';
        var policyStatus = sessionStorage.getItem(CURRENT_POLICY_STATUS) || '';
        var productCode = sessionStorage.getItem(CURRENT_POLICY_PRODUCT_CODE) || '';
        sm.getApi({ version: 'v1' }).then(function (glia) {
            glia.updateInformation({
                customAttributesUpdateMethod: 'merge',
                customAttributes: {
                    policy_number: policyNumber,
                    customer_number: userId,
                    lob: lob,
                    state: state,
                    policy_status: policyStatus,
                    product_code: productCode,
                    authenticated: 'true'
                }
            }).catch(function (error) {
                console.warn('[Glia] updateInformation error:', error);
            });
        }).catch(function (error) {
            console.warn('[Glia] getApi error:', error);
        });
    };
    /**
     * Called on logout — clears visitor context from Glia.
     */
    GliaService.prototype.clearVisitorContext = function () {
        if (typeof sm === 'undefined') {
            return;
        }
        sm.getApi({ version: 'v1' }).then(function (glia) {
            glia.updateInformation({
                customAttributes: {
                    policy_number: '',
                    customer_number: '',
                    authenticated: 'false'
                }
            }).catch(function (error) {
                console.warn('[Glia] clearVisitorContext error:', error);
            });
        });
    };
    GliaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GliaService_Factory() { return new GliaService(); }, token: GliaService, providedIn: "root" });
    return GliaService;
}());
export { GliaService };
